export function saveAnalysisItemMutation(values) {
  const mutationQuery = `mutation {
        analysisItemSave(
            analysisItem: {id: ${values.id ? values.id : 0}
                    , name: "${values.name}"
                    , order: ${
                      values.order
                    }                                        
                    , description: """${
                      values.description ? values.description : ''
                    }"""
                    , active: ${values.active}
                    , filterByStatus: false                                        
                    , updaterId: 0                                        
                    }),
        {id}
    }`;
  return mutationQuery;
}

export function analysisItemListByFilter(filter) {
  const query = `{analysisItemListByFilter(filter:  ${JSON.stringify(
    filter
  ).replace(/"([^(")"]+)":/g, '$1:')}) {id, name, description, active, order}}`;
  return query;
}
